
import {
    FETCH_TAG_SUCCESS,
    FETCH_TAG_ERROR,
    FETCH_TAG_LOADING
} from "../action/index" 

const defaultState= {
    isLoading: true,
    data: [],
}

const tagReducer = (state = defaultState, action ) => {
    switch(action.type){
        case FETCH_TAG_SUCCESS:
            return {...state, data: action.payload, isLoading: false}
        case FETCH_TAG_LOADING:
            return {...state, isLoading: true, error: null}
        case FETCH_TAG_ERROR:
            return {...state, isLoading: false, error: "FETCH_TAG_ERROR"}
        default:
            return {...state};
    }
}

export default tagReducer;